// Local partner directory — Coming Home card destination.
// Each partner listing carries: patch, name, credentials, public URL.
// Update this file as partnerships are signed.

export const EMERGENCY = [
  {
    label: 'Mountain Rescue',
    detail: 'Dial 999 · ask for Police, then Mountain Rescue',
  },
  {
    label: 'Coastguard',
    detail: 'Dial 999 · ask for Coastguard (for lochs & coastal ground)',
  },
  {
    label: 'NHS 24',
    detail: 'Dial 111 · non-emergency medical, 24 hours',
  },
];

/*
 * Partner categories. Each patch begins as `status: 'building'` and moves
 * to `'active'` as an agreement is signed. Placeholder entries flag the
 * intent without misrepresenting a partnership.
 */
export const PATCHES = [
  {
    id: 'cairngorms',
    title: 'Cairngorms National Park',
    status: 'building',
    note:
      'Outreach letter posted to the CNP ranger service. We\u2019ll list their public general-enquiry contact here once permission is confirmed.',
    partners: [],
  },
  {
    id: 'loch-lomond-trossachs',
    title: 'Loch Lomond & The Trossachs National Park',
    status: 'building',
    note:
      'Outreach letter posted to the LLTNP ranger service. We\u2019ll list their public general-enquiry contact here once permission is confirmed.',
    partners: [],
  },
  {
    id: 'perthshire',
    title: 'Perthshire &amp; the Central Highlands',
    status: 'building',
    note:
      'Home ground. We\u2019re actively speaking to MIC- and MIA-qualified guides working out of Pitlochry, Aberfeldy and Dunkeld. Reply if you\u2019d like to be listed.',
    partners: [],
  },
  {
    id: 'skye-and-north-west',
    title: 'Skye &amp; the North-West',
    status: 'building',
    note:
      'Cuillin ridge, Torridon, Applecross \u2014 serious ground. If you guide here and would consider being on our card, we\u2019d be glad to hear from you.',
    partners: [],
  },
];
